import {
  oilChange,
  chassisLube,
  truckCleaning,
  gallery1,
  gallery2,
  gallery3,
  gallery4,
} from "../assets/images";

export const NAV_LINKS = ["Home", "Services", "About", "Contact", "Testimonials"];

export const SERVICES = [
  {
    title: "Repair",
    desc: "We provide fast, professional repair serivices for all classes of commercial trucks. Keeping your trucks running smoothly as they are foundation of a long-lasting fleet.",
    img: oilChange,
    features: ["A/C","Tires", "Engine","Trailer","Brakes","Steering","Electrical","Drivetrain","Suspension","Wheel Seals","Clutch Replacement"],
  },
  {
    title: "Service",
    desc: "Proper greasing of chassis components reduces wear, prevents corrosion, and extends the life of your suspension and steering systems. Our technicians hit every zerk fitting on schedule.",
    img: chassisLube,
    features: ["Preventative Maintenance","Oil Changes","Chassis Lube","Fleet Maintenance"],
  },
  {
    title: "Washing/Detailing",
    desc: "A clean truck is a professional truck. We offer thorough interior and exterior cleaning services designed for commercial vehicles — keeping your rig looking as good as it runs.",
    img: truckCleaning,
    features: ["Hand Washing","Interior Cleaning","Fleet Washing"],
  },
];

export const INITIAL_GALLERY = [
  { id: 1, url: gallery1, caption: "Fleet Oil Change Service" },
  { id: 2, url: gallery2, caption: "Chassis Lubrication" },
  { id: 3, url: gallery3, caption: "Full Truck Detail" },
  { id: 4, url: gallery4, caption: "Commercial Fleet Maintenance" },
];

export const ADMIN_PASSWORD = "rctsadmin2024";

export const INITIAL_TESTIMONIALS = [
  { id: 1, type: "Owner-Operator", name: "Marcus T.", company: "T&T Freight LLC", rating: 5, text: "Race City Truck Solutions has been maintaining our fleet of 8 trucks for over two years. Always on time, thorough, and fair pricing.", service: "Oil Change & Chassis Lubrication", avatar: "MT" },
  { id: 2, type: "Fleet Manager", name: "Sandra H.", company: "Haulers Direct Inc.", rating: 5, text: "Switched to Race City after our old shop kept missing lube points. Night and day difference. Our trucks have never run smoother.", service: "Chassis Lubrication", avatar: "SH" },
  { id: 3, type: "Owner-Operator", name: "Derrick W.", company: "Independent", rating: 5, text: "These guys knocked out my oil change and full clean in record time. My truck looked brand new walking out of there.", service: "Oil Change & Truck Cleaning", avatar: "DW" },
  { id: 4, type: "Fleet Manager", name: "Brenda K.", company: "Lakeview Distribution", rating: 4, text: "Great service, great people. They never try to upsell you on things you do not need.", service: "Oil Change", avatar: "BK" },
];